import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputBase from '@material-ui/core/InputBase';
import { getModalidad } from '../../sagas/ConfigGlobalSaga/calls';
import './styles.css';

const modalidad = getModalidad();

const RegistrarUsuario = (props) => {
    const [modalidad, setModalidad] = useState('');
    const [error, setError] = useState(null);

    useEffect(() => {
        getModalidad()
            .then(modalidad => {
                setModalidad(modalidad);
                setError(null);
            })
            .catch(error => {
                setError(error.message);
            });
    }, []);

    const handleCuilChange = (event) => {
        const { value } = event.target;
        if (value.length <= 11 && !isNaN(value)) {
            props.handleOnDataChange(event);
        }
    };

    let handleKeyPress = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isNumber = /^[0-9]*$/;
        const currentValue = event.target.value;

        if (!isNumber.test(keyValue) || currentValue.length >= 9) {
            event.preventDefault();
        }
    };

    const handleKeyPressPhoneNumber = (event) => {
        const keyCode = event.keyCode || event.which;
        const keyValue = String.fromCharCode(keyCode);
        const isNumber = /^[0-9]*$/;
        const currentValue = event.target.value;

        if (!isNumber.test(keyValue) || currentValue.length >= 12) {
            event.preventDefault();
        }
    };


    return (
        <div className='registrarUsuarioFormContainer'>
            <div className='containerForm'>

                <div className='logoContainer center'>
                    <img alt='' src={props.instalacion.logoLogin} />
                </div>

                {!props.usuarioCreado &&
                    <div style={{ width: '100%' }}>
                        <div className='inputContainer'>
                            <InputBase
                                placeholder="Nombre"
                                value={props.usuario.nombre}
                                name="nombre"
                                onChange={props.handleOnDataChange}
                                error={props.errores.nombre !== undefined}
                            />
                            {props.errores.nombre !== undefined &&
                                <FormHelperText error>{props.errores.nombre}</FormHelperText>}
                        </div>

                        <div className='inputContainer'>
                            <InputBase
                                placeholder="Apellido"
                                value={props.usuario.apellido}
                                name="apellido"
                                onChange={props.handleOnDataChange}
                                error={props.errores.apellido !== undefined}
                            />
                            {props.errores.apellido !== undefined &&
                                <FormHelperText error>{props.errores.apellido}</FormHelperText>}
                        </div>

                        <div className='inputContainer'>
                            <InputBase
                                placeholder="Email"
                                value={props.usuario.email}
                                name="email"
                                onChange={props.handleOnDataChange}
                                error={props.errores.email !== undefined}
                            />
                            {props.errores.email !== undefined &&
                                <FormHelperText error>{props.errores.email}</FormHelperText>}
                        </div>
                        <div className='inputContainer'>
                                <InputBase
                                    name="phoneNumber"
                                    placeholder="Celular (solo números)"
                                    value={props.usuario.phoneNumber}
                                    onChange={props.handleOnDataChange}
                                    onKeyPress={handleKeyPressPhoneNumber}
                                />
                                {props.errores.phoneNumber !== undefined &&
                                    <FormHelperText error>{props.errores.phoneNumber}</FormHelperText>}
                            </div>
                        <div>
                            {modalidad === 'Mayorista' && (
                                <div className='inputContainer'>
                                    <InputBase
                                        placeholder="CUIT / CUIL (solo números)"
                                        value={props.usuario.cuit}
                                        name="cuit"
                                        onChange={handleCuilChange}
                                        error={props.errores.cuit !== undefined}
                                    />
                                    {props.errores.cuit !== undefined && (
                                        <FormHelperText error>{props.errores.cuit}</FormHelperText>
                                    )}
                                </div>
                            )}

                            {modalidad === 'Mayorista' && (
                                <div className='inputContainer'>
                                    <InputBase
                                        placeholder="Razón social"
                                        value={props.usuario.razonSocial}
                                        name="razonSocial"
                                        onChange={props.handleOnDataChange}
                                        error={props.errores.razonSocial !== undefined}
                                    />
                                    {props.errores.razonSocial !== undefined &&
                                        <FormHelperText error>{props.errores.razonSocial}</FormHelperText>}
                                </div>
                            )}
                        </div>

                        {modalidad === 'Minorista' && (
                            <div className='inputContainer'>
                                <InputBase
                                    name="dni"
                                    placeholder="DNI (solo números)"
                                    value={props.usuario.dni}
                                    onChange={props.handleOnDataChange}
                                    onKeyPress={handleKeyPress}
                                />
                                {props.errores.dni !== undefined &&
                                    <FormHelperText error>{props.errores.dni}</FormHelperText>}
                            </div>
                        )}

                        <div className='inputContainer'>
                            <InputBase
                                placeholder="Domicilio"
                                value={props.usuario.domicilio}
                                name="domicilio"
                                onChange={props.handleOnDataChange}
                                error={props.errores.domicilio !== undefined}
                            />
                            {props.errores.domicilio !== undefined &&
                                <FormHelperText error>{props.errores.domicilio}</FormHelperText>}
                        </div>

                        <div className='inputContainer'>
                            <InputBase
                                placeholder="Contraseña"
                                value={props.usuario.password}
                                type="password"
                                name="password"
                                onChange={props.handleOnDataChange}
                                error={props.errores.password !== undefined}
                            />
                            {props.errores.password !== undefined &&
                                <FormHelperText error>{props.errores.password}</FormHelperText>}
                        </div>

                        <div className='myLabel error' style={{ visibility: props.error ? 'visible' : 'hidden' }} >{props.errorAutenticacion || ''}</div>

                        <div className='buttonContainer'>
                            <Button className='btnPrincipal' onClick={props.handleOnSave}>Registrarme</Button>
                        </div>

                        <Link to='/Login'>
                            <div className='myLabel link' style={{ textAlign: 'center' }}>Ya tengo cuenta</div>
                        </Link>
                    </div>}

                {props.usuarioCreado && !props.codigoVerificado &&
                    <div>
                        <div className='labelInfoCodigo'>{`Le enviamos un código a su correo ${props.usuario.email}`}</div>

                        <div className='inputContainer' style={{ margin: '30px 0px' }}>
                            <InputBase
                                placeholder="Código"
                                value={props.usuario.codigoVerificacion}
                                name="codigoVerificacion"
                                onChange={props.handleOnDataChange}
                                error={props.errores.codigoVerificacion !== undefined}
                            />
                            {props.errores.codigoVerificacion !== undefined &&
                                <FormHelperText error>{props.errores.codigoVerificacion}</FormHelperText>}
                        </div>

                        <div className='buttonContainer'>
                            <Button className='btnPrincipal' onClick={props.handleOnConfirmarCódigo}>Confirmar código</Button>
                        </div>

                        <div style={{ marginTop: '10px' }}>
                            <div className='labelReenvioCodigo'>No encuentras el código? <b onClick={props.handleOnReenviarCodigo} className='linkReenviar'>Reenviar código</b></div>
                            <div className='labelReenvioCodigo'>No olvides buscar en tu carpeta de Spam</div>
                        </div>
                    </div>}

                {props.usuarioCreado && props.codigoVerificado &&
                    <div>
                        <div className='labelInfoCodigo' style={{ marginBottom: '10px' }}>{`Su cuenta ha sido verificada con éxito!`}</div>
                        <div className='labelInfoCodigo' style={{ marginBottom: '40px' }}>{`Espere a que su cuenta sea habilitada por nosotros`}</div>

                        <Link to='/Login'>
                            <div className='buttonContainer'>
                                <Button className='btnPrincipal'>Ir al Login</Button>
                            </div>
                        </Link>
                    </div>
                }
            </div>
        </div>
    );
}

RegistrarUsuario.propTypes = {
    instalacion: PropTypes.object.isRequired,
    usuario: PropTypes.object.isRequired,
    datosClienteHabilitados: PropTypes.bool.isRequired,
    handleOnCancelar: PropTypes.func.isRequired,
    handleOnSave: PropTypes.func.isRequired,
    errores: PropTypes.object,
    usuarioCreado: PropTypes.bool.isRequired,
    handleOnDataChange: PropTypes.func.isRequired,
    handleOnConfirmarCódigo: PropTypes.func.isRequired,
    handleOnReenviarCodigo: PropTypes.func.isRequired,
    codigoVerificado: PropTypes.bool.isRequired,
}

RegistrarUsuario.defaultProps = {
    errores: {}
}

export default RegistrarUsuario;
